import { HiMenuAlt2 } from "react-icons/hi";

import { useSidebar } from "../sidebar-nav/use-sidebar";
import { ThemeToggle } from "../theme-toggle/theme-toggle";
import { UserMenu } from "./user-menu";
import { cn } from "@/lib/utils";
import { AdminNotifications } from "./notification/admin-notifications";
import { EmployeeNotifications } from "./notification/employee-notifications";
import { CreationForAdmin } from "./creation";
import { Announcement } from "./creation/announcement";
import { JustBeforeLogoutModal } from "./_comps/just-before-logout-modal/just-before-logout-modal";
import { MobileSheet } from "./mobile-sheet";
import { TodoSnippet } from "./todo-snippet";
import { BreakControl } from "./break-control/break-control";

export const DashboardNavbar = () => {
  const { onOpenChange, open } = useSidebar();
  const userRole = localStorage.getItem("userRole") as string;

  const handleSidebar = () => {
    if (open) {
      onOpenChange(false);
    } else {
      onOpenChange(true);
    }
  };

  return (
    <div
      className={cn(
        "fixed h-14 bg-muted flex items-center px-5 w-full z-50",
        open ? "md:w-[calc(100%-220px)] lg:w-[calc(100%-240px)]" : "w-full"
      )}
    >
      <div className="flex-1 h-full flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* For Above Mobile Screen */}
          <button
            className="group transition-all duration-300 hover:bg-ring/10 p-1.5 rounded-full active:scale-[0.95] hidden sm:block"
            onClick={handleSidebar}
          >
            <HiMenuAlt2 className="w-5 h-5" />
          </button>

          {/* For Mobile or less */}
          <MobileSheet />
          <ThemeToggle />
        </div>

        <div className="flex items-center gap-6">
          {userRole === "employee" && <BreakControl />}
          {userRole === "employee" && <TodoSnippet />}
          {userRole === "admin" ? (
            <AdminNotifications />
          ) : userRole === "employee" ? (
            <EmployeeNotifications />
          ) : null}

          {userRole === "admin" && <CreationForAdmin />}
          <UserMenu />
        </div>
      </div>

      {userRole === "admin" && <Announcement />}

      <JustBeforeLogoutModal />
    </div>
  );
};
